import React from 'react';
import PropTypes from 'prop-types';

import OEToolbox from '../../lib/tools/oe-toolbox-core';

const OEIconVAlignMap = new Map([
    ['\uF2A9', 'middle'],        // animation icon
    ['\u2004', 'middle'],        // other animation icon
    ['\u2009', 'middle'],
    ['\uF238', 'middle'],       // eye anatomy icon
    ['\uF23A', 'middle'],       // opti icon
    ['\uF053', 'middle'],       // chevron left
    ['\uF054', 'middle'],       // chevron right
    //['\uF009', 'middle'],       // start selection icon
    ['\uF21A', 'middle']        // key icon
]);

export default class OEIcon extends React.PureComponent {

    constructor(props)  {
        super(props);
        this.state = {
            code: this.resolveCode(this.props.code),
            subCode: this.resolveSubCode(this.props.code),
            subCode2: this.resolveSubCode2(this.props.code),
            className: this.getClassName(),
            subIconClassName: this.getSubIconClassName(),
            subIcon2ClassName: this.getSubIcon2ClassName()
        };
    }

    resolveCode(code)   {
        return typeof(code) === 'object' ? (code.code ? code.code : '') : code;
    }

    resolveSubCode(code)   {
        return typeof(code) === 'object' ? (code.subCode ? code.subCode : '') : '';
    }

    resolveSubCode2(code)   {
        return typeof(code) === 'object' ? (code.subCode2 ? code.subCode2 : '') : '';
    }

    codeToClassNameString(code) {
        if(!code)   return '';

        let strCode = '';
        for(const codePoint_ of code) {
            let codePoint = codePoint_.codePointAt(0).toString(16);
            let strLeadingZeros = '';
            for(let j = codePoint.length; j < 4; j++) strLeadingZeros += '0';
            strCode += 'u' + strLeadingZeros + codePoint.toUpperCase();
        }

        return strCode;
    }

    getClassName(props) {
        props = props || this.props;
        let ret = 'icon effigos-symbol';
        let code = this.resolveCode(props.code);
        
        //
        let align = OEIconVAlignMap.get(code);
        if(align)   ret = ret + ' valign-' + align;
        
        //
        if(props.className) ret += ' ' + props.className;

        //
        let strCode = this.codeToClassNameString(code);
        if(strCode) ret += ' icon-code-' + strCode;

        //
        if(typeof(props.code) === 'object' && typeof(props.code.className) === 'string')    ret += ' ' + props.code.className;

        return ret;
    }

    getSubIconClassName(props) {
        props = props || this.props;
        let ret = 'sub-icon';
        let code = this.resolveSubCode(props.code);
        
        //
        let strCode = this.codeToClassNameString(code);
        if(strCode) ret += ' sub-icon-code-' + strCode;

        //
        if(typeof(props.code) === 'object' && typeof(props.code.subClassName) === 'string')    ret += ' ' + props.code.subClassName;

        return ret;
    }

    getSubIcon2ClassName(props) {
        props = props || this.props;
        let ret = 'sub-icon-2';
        let code = this.resolveSubCode2(props.code);
        
        //
        let strCode = this.codeToClassNameString(code);
        if(strCode) ret += ' sub-icon-code-2-' + strCode;

        //
        if(typeof(props.code) === 'object' && typeof(props.code.subClassName2) === 'string')    ret += ' ' + props.code.subClassName2;

        return ret;
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.className != this.props.className || !OEToolbox.shallowEqual(nextProps.code, this.props.code, true))     {
            this.setState({
                code: this.resolveCode(nextProps.code),
                subCode: this.resolveSubCode(nextProps.code),
                subCode2: this.resolveSubCode2(nextProps.code),
                className: this.getClassName(nextProps),
                subIconClassName: this.getSubIconClassName(nextProps),
                subIcon2ClassName: this.getSubIcon2ClassName(nextProps)
            })
        }
    }

    renderSubIcon() {
        if(!this.state.subCode)   return null;
        return (
            <div className={this.state.subIconClassName}>
                {this.state.subCode}
            </div>
        );
    }

    renderSubIcon2() {
        if(!this.state.subCode2)   return null;
        return (
            <div className={this.state.subIcon2ClassName}>
                {this.state.subCode2}
            </div>
        );
    }

    render()    {
        return (
            <div className={this.state.className} style={this.props.style}>
                {this.renderSubIcon()}
                {this.renderSubIcon2()}
                <div className="icon-content">
                    {this.state.code}{this.props.children}
                </div>
            </div>
        );
    }
}

OEIcon.defaultProps = {
    className:              '',
    code:                   ''
};

OEIcon.propTypes = {
    className:              PropTypes.string,
    style:                  PropTypes.object,
    code: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            code:           PropTypes.string,
            subCode:        PropTypes.string,
            subCode2:       PropTypes.string,
            className:      PropTypes.string,
            subClassName:   PropTypes.string,
            subClassName2:  PropTypes.string
        })
    ])
};